var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"data":{
			name: 'Clients Import',
			breadcrumbs: [
				{ name: 'Home', to: '/' },
				{ name: 'Clients', to: '/clients' } ],
		}}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('LPDataImporter',{attrs:{"tableName":'clients'}})],1)])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }